export default "__VITE_ASSET__66b0ebcd__"